<!--
 * @Author: wjl
 * @Date: 2020-08-26 11:09:35
 * @LastEditors: wjl
 * @LastEditTime: 2020-12-17 14:52:22
 * @FilePath: \appOfficial\src\views\PayMode.vue
-->
<template>
  <div class="contrainer" :style="isPc ? 'width:1100px' : ''">
    <h1>网上老年大学用户充值购买协议</h1>
    <p>
      您在注册、登录网上老年大学平台、使用网上老年大学平台充值、购买服务之前，应当认真阅读并充分理解《网上老年大学用户充值购买协议》（以下简称“本协议”）中各条款。
      <span
        >您应该具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备签署与您行为相适应的民事行为能力，请确保您的监护人同意您的所有行为，在此情况下，您及您的监护人应依照法律规定承担因此而导致的一切后果。</span
      >
      <br />
      <br />
      <span
        >免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如果您对本协议的任何条款表示异议，或者无法准确理解本协议，请不要使用网上老年大学平台购买服务。您使用购买服务等行为视为对本协议全部内容的接受，也意味您将接受本协议以及未来针对本协议更新版本条款的约束，并服从网上老年大学平台统一管理。网上老年大学可能会不定期的更新本协议内容，用户可在网上老年大学软件内页或网页查阅最新版协议条款。更新后的协议条款一旦公布即代替原来的协议条款。协议条款更新后，如用户不同意接受，用户应停止使用网上老年大学提供的服务。</span
      >
    </p>
    <br />
    <p>
      本协议是您（以下简称“用户”）与网上老年大学平台（以下简称
      “网上老年大学”）之间关于使用网上老年大学购买服务所订立的协议。“用户”是指注册、登录、使用网上老年大学购买服务的个人。
    </p>
    <br />
    <h2>一、购买服务程序</h2>
    <h3>1. 充值学币购买</h3>
    <p>
      <span
        >（1）
        “学币”是网上老年大学向用户提供的用于在网上老年大学上进行相关消费的虚拟货币，用户可依照购买规则，先进行账户充值，购买学币，然后使用充值账号内的“学币”购买网上老年大学某项产品或服务。用户了解及确认，用户购买及使用“学币”的范围以网上老年大学认可的范围为准。</span
      >
    </p>
    <br />
    <p>
      <span
        >（2）
        用户了解并确认，各应用商店可能会对充值渠道、充值频率等进行限定，并可能会要求网上老年大学隔离不同系统、不同应用商店适用的移动客户端及/或未来增加的网上老年大学平台的账号信息，包括账号余额、账号交易记录等。</span
      >
    </p>
    <h3>2. 直接购买</h3>
    <p>
      （1）
      用户可按照购买规则，通过网上老年大学认可的支付方式，直接购买网上老年大学的某项产品或服务。如用户希望使用直接购买服务，需先登录用户的网上老年大学账号。
      <span
        >用户了解及确认，用户可直接购买的网上老年大学服务以网上老年大学认可的范围为准。</span
      >
    </p>
    <br />
    <h2>二、充值服务及/或购买服务规则</h2>
    <p>
      1.
      用户在使用充值服务及/或购买服务时，务必仔细了解本协议及网上老年大学不时公布和更新的各项规则，并根据网上老年大学操作提示，确认自己的账号并选择相关操作选项。
      <span
        >使用充值服务及/或购买服务时，用户应确保用户是该充值及/或购买账号的权利人，可合法、有效使用该账号且未侵犯任何第三方合法权益，否则因此造成充值及/或购买账户实际所有人损失的，用户应单独负责解决由此产生的纠纷并承担全部法律责任。</span
      >
    </p>
    <br />
    <p>
      <span
        >2.
        一旦账户充值成功，除法律规定的情形及本协议另有约定外，网上老年大学不会就账户内的“学币”余额提供任何退还或逆向兑换（即“学币”兑换为人民币或其他货币）服务。</span
      >
    </p>
    <br />
    <p>
      <span
        >3.
        用户在使用购买服务时，应仔细核对网上老年大学账号名称、课程名称、课程费用、课程有效期等具体信息。一旦购买成功，除法律规定的情形及本协议另有约定外，网上老年大学不予退还已收取的费用/学币。</span
      >
    </p>
    <br />
    <p>
      <span
        >4.
        用户使用购买服务购买的内容仅限于用户自行使用，不能在不同的网上老年大学用户账号之间转移。不能就购买的内容进行复制、销售或进行其他传播行为。</span
      >
    </p>
    <br />
    <p>
      5.
      如果网上老年大学发现因网上老年大学平台系统故障导致的充值/购买结果处理错误，无论有利于网上老年大学还是有利于用户，网上老年大学都有权在以网上老年大学平台公告或其他合理方式通知用户后纠正该错误。其中，如果该措施导致用户实际充值购买的“学币”数量少于用户应获得的“学币”及/或实际购买的网上老年大学服务数量少于用户应获得的网上老年大学服务，则用户有权通知网上老年大学。网上老年大学在调查及确认该处理错误后会尽快将差额补足至用户的账户中，或进行线下退款处理。如果该错误导致用户实际收到的“学币”数量多于用户应获得的“学币”及/或实际购买的网上老年大学服务数量多于用户应获得的网上老年大学服务，则无论错误的性质和原因如何，网上老年大学有权从用户的账户中直接扣除多得的“学币”及/或服务。
    </p>
    <br />
    <h2>三、权利声明</h2>
    <br />
    <p>
      1. 用户可在网上老年大学
      “我的”页面查看其“学币”的余额情况及/或查看网上老年大学服务的购买情况。如用户对上述记录有异议，应立即向网上老年大学提出，网上老年大学调查核对后确有错误的，将予以更正。否则用户同意网上老年大学上的交易记录将作为“学币”交易、余额情况、网上老年大学服务购买情况的唯一有效依据。
    </p>
    <br />
    <p>
      <span
        >2.
        因用户自身的原因导致网上老年大学无法提供充值服务/购买服务或提供充值服务/购买服务时发生任何错误而产生的任何损失，由用户自行负责，网上老年大学不提供退、换服务，亦不会作出任何补偿或赔偿，包括但不限于：</span
      >
      <br />
      <span
        >（1）
        用户未按照本协议或网上老年大学不时公布和更新的规则进行充值服务/购买服务操作；</span
      >
      <br />
      <span>（2） 因用户的账号失效、丢失、被封停；</span>
      <br />
      <span
        >（3）
        因用户自身输入账号错误、操作不当等因素造成充错账号、错选购买种类、错选购买金额、错选购买服务有效期；</span
      >
      <br />
      <span
        >（4）
        因用户绑定的第三方支付账户之原因导致的损失，包括但不限于第三方支付账户被冻结、查封等；</span
      >
      <br />
      <span>（5） 因用户设置或保管密码不当导致的财产损失；</span>
      <br />
      <span>（6） 因用户个人的故意或重大过失所造成的财产损失。</span>
    </p>
    <br />
    <h2>四、处罚规则</h2>
    <p>
      <span>1. 如用户实施了下列行为之一：</span>
      <br />
      <span>（1） 以营利为目的为自己或他人获得充值服务及/或购买服务的；</span>
      <br />
      <span
        >（2）
        将通过充值服务及/或购买服务获得的任何内容用于复制、销售、传播或本协议约定之外用途的；</span
      >
      <br />
      <span>（3） 盗用他人网上老年大学账号进行充值服务及/或购买或使用的；</span>
      <br />
      <span
        >（4）
        以任何系统BUG、漏洞、机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得充值服务及/或购买服务的；</span
      >
      <br />
      <span
        >（5）
        其他通过不正当手段或以违反诚实信用原则的行为获得充值服务及/或购买服务的。</span
      >
      <br />
      <br />
      <span
        >网上老年大学及其关联公司有完全的权利在不通知用户的情况下，视严重情况，对用户同时采取以下单项或多项措施进行处罚，同时网上老年大学及其关联公司无须给予用户任何补偿和退费、不予返还用户购买“学币”所支付的对价，由此产生的责任由用户自行独立承担。因此给网上老年大学及其关联公司或第三方造成损失的，用户应负责全额赔偿（包括但不限于赔偿金、罚金、和解费、诉讼仲裁费、合理的律师费支出等）。</span
      >
      <br />
      <span>（1） 暂停或终止提供全部或部分网上老年大学服务；</span>
      <br />
      <span>（2） 暂时限制或永久封禁相关用户网上老年大学账号；</span>
      <br />
      <span
        >（3）
        对相关用户网上老年大学账户中全部或部分的“学币”余额进行冻结或清空；</span
      >
    </p>
    <br />
    <h2>五、法律</h2>
    <p>
      <span
        >1.
        本协议适用中华人民共和国大陆地区施行的法律。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关协议将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。</span
      >
    </p>
    <br />
    <p>
      <span
        >2.
        凡因本合同引起的或与本合同有关的任何争议，均应提交中国国际经济贸易仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁地点为北京，应由三名仲裁员组成仲裁庭。仲裁裁决是终局的，对双方均有约束力。</span
      >
    </p>
    <h2>六、附则</h2>
    <p>
      <span
        >1.
        用户充分理解并同意：因业务发展需要、突发情势等，网上老年大学可能会变更，暂停、限制或者终止部分或全部服务。届时，如用户按照本协议约定履行义务的，网上老年大学会依法保护用户的合法权益。除法律有明确规定的情况外，网上老年大学有权不经用户申请直接为用户办理退款。</span
      >
    </p>
    <br />
    <p>
      2.
      网上老年大学不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响网上老年大学在将来行使该权利。
    </p>
    <br />
    <p>
      3.
      如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议条款的其余条款仍应有效且具有约束力，网上老年大学及用户均应尽力使该协议设定的本意得到实现。
    </p>
    <br />
    <p>4. 本协议中的标题仅为方便而设，不作为解释本条款的依据。</p>
    <br />
    <p>5. 如有任何疑问，请在APP内联系客服。</p>
  </div>
</template>

<script>
export default {
  name: "Xieyi",
  data() {
    return {
      isPc: true,
    };
  },
  mounted() {
    this.isPc = this.modoule();
  },
  methods: {
    modoule() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.contrainer {
  padding: 20px;
  padding-top: 0;
  margin: 0 auto;
}
h1 {
  font-size: 16pt;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: black;
  line-height: 16.5pt;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
h2 {
  font-size: 15pt;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: black;
  line-height: 16.5pt;
  margin: 10px 0;
}
h3 {
  font-size: 14pt;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: black;
  line-height: 16.5pt;
  margin: 15px 0;
}
p {
  font-size: 12.5pt;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: black;
  line-height: 18.5pt;
  text-align: justify;
  text-indent: 2.66vw;
  span {
    font-weight: 600;
  }
}
</style>
